module.exports = __webpack_public_path__ + "c248daa17bc44081f6fb6eb8aba9a5fb.gif";